import { observable, action, makeObservable } from 'mobx';
// import * as API from '@/api';
import { Stomp, CompatClient } from '@stomp/stompjs';
import { meeting } from '.';

const REDELAY = 5000;

class StompInstance {
  constructor() {
    makeObservable(this);
  }

  @observable client: CompatClient | null = null;

  @observable responseBody: {
    data: any;
    commandId: number;
    channelId: number;
    sender: string;
    serviceId: number;
    timestamp: number;
  } | null = null;

  @action
  connect(cid: string, sessionId: string, uid: string) {
    if (!cid || !sessionId || !uid) return;
    if (this.client) return;
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    // const url = `${protocol}://${
    //   window.location.host
    // }/api/bs-vmeeting-websocket/v1/stomp?meeting=${cid}&session=${sessionId}&user=${encodeURIComponent(
    //   uid
    // )}`;
    // var url = `${protocol}://test-meet.popo.netease.com:9080/api/bs-vmeeting-websocket/v1/stomp?meeting=${cid}&session=${sessionId}&user=${encodeURIComponent(
    //   uid,
    // )}`;

    const url = meeting?.info?.notifyStompAuth?.stompEndpoint!;
    if (url) {
      this.client = Stomp.client(url);
      this.client.reconnect_delay = REDELAY;
    }

    const successCallback = () => {
      if (!this.client) return;
      // 连接成功时（服务器响应 CONNECTED 帧）的回调方法
      const subscribeList = meeting.info?.notifyStompAuth?.stompDestinations;
      subscribeList?.forEach((destination) => {
        this.client.subscribe(destination, (response) => {
          if (response.body) {
            this.responseBody = JSON.parse(response.body);
            console.log(destination, JSON.parse(response.body), 'stomp response');
          }
        });
      });
    };
    const errorCallback = () => {
      // 连接失败时（服务器响应 CONNECTED 帧）的回调方法
      // eslint-disable-next-line no-use-before-define
      setTimeout(connect, REDELAY);
    };
    const closeCallback = (e: any) => {
      console.log(e, 'close cb');
      // eslint-disable-next-line no-use-before-define
      setTimeout(connect, REDELAY);
    };
    // 向服务器发起websocket连接并发送CONNECT帧
    const connect = () => {
      this.client?.connect({}, successCallback, errorCallback, closeCallback);
    };
    connect();
  }

  @action
  disconnect() {
    if (!this.client) return;
    this.client.disconnect(() => {
      console.log('stomp disconnect ----');
    });
  }
}

export default StompInstance;
